/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{margin:0;padding:0}.footerStyle[_ngcontent-%COMP%]{width:100%;height:auto;text-align:right}.textStyle[_ngcontent-%COMP%]{margin-right:2%;color:#a9a9a9}"];
export { styles as styles };
